import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import { Tooltip } from 'antd';
import { get } from 'lodash';

import FundkyButton from 'Parts/ui/components/FundkyButton';
import FundkyModal from 'Parts/ui/components/FundkyModal';
import ChooseTicketsForm from './ChooseTicketsFormContainer';

import BuyTicketBtn_en from './locales/BuyTicketBtn_en.json';
import BuyTicketBtn_fr from './locales/BuyTicketBtn_fr.json';

import './BuyTicketBtn.less';

class BuyTicketBtn extends React.Component {
    constructor(props) {
        super(props);

        props.fetchTicketList(props.entity.id, { showDescription: true });

        // [MOTIVACTION]
        // - Hide remaining ticket
        // - Display "Participate" instead of "Buy ticket"
        this.exceptions_MOTIVACTION = [
            //{environment: "development", organizationId: 40, platformId: 66, campaignId: 397},
            //{environment: "preproduction", organizationId: 26, platformId: 27, campaignId: 385},
            {environment: "production", organizationId: 59, platformId: 100, campaignId: 519},
        ];

        // [REMAX]
        // - Modify button label text for "Order/Commander"
        // - Hide remaining tickets count
        this.exceptions_REMAX = [
            //{environment: "development", organizationId: 40, platformId: 66, campaignId: 405},
            //{environment: "preproduction", organizationId: 26, platformId: 27, campaignId: 386},
            {environment: "production", organizationId: 75, platformId: 128, campaignId: 608},
            {environment: "production", organizationId: 75, platformId: 128, campaignId: 609},
            {environment: "production", organizationId: 75, platformId: 128, campaignId: 610},
        ];

        // [REMAX2]
        // - Modify button label text for "Buy/Acheter"
        this.exceptions_REMAX2 = [
            {environment: "development", organizationId: 40, platformId: 66, campaignId: 405},
            {environment: "preproduction", organizationId: 26, platformId: 27, campaignId: 386},
            {environment: "production", organizationId: 75, platformId: 128, campaignId: 993},
        ];

        this.state = {
            modalWidth: '50%',
            modal: props.modal,
            isException_MOTIVACTION: this.checkExceptions(this.exceptions_MOTIVACTION, this.props.entity),
            isException_REMAX: this.checkExceptions(this.exceptions_REMAX, this.props.entity),
            isException_REMAX2: this.checkExceptions(this.exceptions_REMAX2, this.props.entity),
            isLoggedIn: props.userTypeId === 2,
            lastAction: null,
        };

        if (typeof window !== 'undefined') window.addEventListener('resize', this.handleResize);

        this.buyModalRef = React.createRef();

        i18next.addResourceBundle('en', 'BuyTicketBtn', BuyTicketBtn_en);
        i18next.addResourceBundle('fr', 'BuyTicketBtn', BuyTicketBtn_fr);
    }

    componentDidMount() {
        const { props, state, handleResize, handleShowModal } = this,
            { t, locale, history, entity, isBillingConfigured } = props,
            { modal } = state;

        if (typeof window !== 'undefined')
            handleResize();

        if ( 
            modal === t('URL:ticket-purchase/choose') ||
            get(history, 'location.pathname') &&
            get(history, 'location.pathname').indexOf(t('URL:ticket-purchase/choose')) >= 0
        ) {
            if (this.props.isBillingConfigured) {
                handleShowModal();
            } else {
                history.push(
                    `/${locale}/${entity.alias}`
                );
            }

        }

        this.setState({
            isException_MOTIVACTION: this.checkExceptions(this.exceptions_MOTIVACTION, this.props.entity),
            isException_REMAX: this.checkExceptions(this.exceptions_REMAX, this.props.entity),
            isException_REMAX2: this.checkExceptions(this.exceptions_REMAX2, this.props.entity),
        });
    }

    componentDidUpdate(prevProps) {
        var _self = this;
        const { props, state, setState, handleHideModal } = this;
        if (prevProps.modal !== null && props.modal === null && state.modal !== null) {
            setState({
                modal: null
            });
            handleHideModal();
        }

        if (prevProps.entity.id !== this.props.entity.id) {
            setState({
                isException_MOTIVACTION: this.checkExceptions(this.exceptions_MOTIVACTION, this.props.entity),
                isException_REMAX: this.checkExceptions(this.exceptions_REMAX, this.props.entity),
                isException_REMAX2: this.checkExceptions(this.exceptions_REMAX2, this.props.entity)
            });
        }

        if (prevProps.userTypeId !== this.props.userTypeId && (this.props.userTypeId === 2) !== this.state.isLoggedIn) {
            this.setState({
              isLoggedIn: this.props.userTypeId === 2
            });

            if (this.state.lastAction === 'submit') {
              setTimeout(function() {
                if (!get(_self.props, 'entity.participating')) {
                    _self.buyModalRef.current.getWrappedInstance('FundkyModal').showModal();
                } else {
                  _self.handleHideModal();
                }
                this.setState({
                    lastAction: null
                });
              }, 1000);
            }
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined')
            window.removeEventListener('resize', this.handleResize);
    }

    checkExceptions = (exceptions, entity) => {
        let environment = ENVIRONMENT;
        let organizationId = entity.organization.id;
        let platformId = entity.platform.id;
        let campaignId = entity.id;

        return exceptions.filter(exc => {
            return exc.environment === environment &&
                exc.organizationId === organizationId &&
                exc.platformId === platformId &&
                exc.campaignId === campaignId;
        }).length ? true : false;
    };

    handleShowModal = e => {
        e && e.preventDefault();
        const { t, history, openLoginModal } = this.props;
        if(!document.querySelector('.ChooseTicketsForm__Modal')) {
            if (this.state.isLoggedIn) {
                this.buyModalRef.current.getWrappedInstance('FundkyModal').showModal();
            } else {
                const customAlert = {
                    title: t('notification-not-logged-in-title'),
                    description: t('notification-not-logged-in-description')
                };
                this.setState({ lastAction: 'submit' });
                openLoginModal(
                    false,
                    customAlert,
                    history.location.pathname +
                    (
                        get(history, 'location.pathname').indexOf(t('URL:ticket-purchase/choose')) < 0
                            ? '/' + t('URL:ticket-purchase/choose')
                            : ''
                    )
                );
            }

        }
    };

    handleHideModal = e => {
        e && e.preventDefault();
        this.buyModalRef.current.getWrappedInstance('FundkyModal').hideModal();
    };

    handleResize = () => {
        const width = window.innerWidth;
        let modalWidth = '50%';

        if (typeof window !== 'undefined') {
            if (width >= 1000) modalWidth = '50%';
            if (width < 1000) modalWidth = '75%';
            if (width <= 500) modalWidth = '100%';
        }

        if (modalWidth !== this.state.modalWidth) {
            this.setState({
                modalWidth: modalWidth
            });
        }
    };

    render() {
        const { props, state, buyModalRef, handleShowModal, handleHideModal } = this,
            { t, locale, entity, history, tickets, template, plural, settings, isBillingConfigured } = props,
            { modal, modalWidth, isException_MOTIVACTION, isException_REMAX, isException_REMAX2 } = state;

        let available = 0;
        let total = 0;
        let sold = 0;
        let limit = 0;
        let noTicketYet = get(tickets, 'results.length', 0) <= 0 ? true : false;
        let remainingTickets = false;
        if (get(tickets, 'results.length')) {
            tickets.results.forEach((ticket)=> {
                if(ticket.displayAvailability){
                    available += ticket.available;
                    total += ticket.quantity;
                }
                if (ticket.available) {
                    remainingTickets = true
                }
            });
            sold = total - available;
            if (get(settings, 'ticket.limit')) {
                limit = parseInt(get(settings, 'ticket.limit'));
            }
            if (limit && limit < total) {
                total = limit;
                available = total - sold;
            }
        }

        const button = (
            <FundkyButton
                className={template === "menu" ? "BuyTicketBtn templateMenu" : "BuyTicketBtn templateButton"}
                text={t(
                    isException_REMAX2
                        ? 'buy'
                        : isException_REMAX
                            ? 'remax-btn-label'
                            : isException_MOTIVACTION
                                ? 'participate'
                                : plural
                                    ? 'buy-tickets'
                                    : 'buy-ticket'
                )}
                size="large"
                type="secondary"
                icon={['fal', 'ticket-alt']}
                iconPosition={template === "menu" ? "before" : ""}
                action={{ func: handleShowModal }}
                disabled = {
                    !isBillingConfigured ||
                    get(tickets, 'results.length', 0) == 0 ||
                    available <= 0 && !remainingTickets
                        ? true
                        : false
                }
            />
        );

        const buyTicket =
            <div className="BuyTicketBtn__Container">
                {button}
                {(!isException_MOTIVACTION && !isException_REMAX || available <= 0 && !remainingTickets) &&
                (available > 0 && isBillingConfigured
                    ? <p>{t('ticket-left', {count: available})}</p>
                    : noTicketYet || !isBillingConfigured
                        ? <p>{t('no-ticket-yet')}</p>
                        : available <= 0 && !remainingTickets
                            ? <p>{t('all-sold')}</p>
                            : null
                )}
            </div>;

        return (
            <>
                {buyTicket}
                <FundkyModal
                    title={t('choose-your-tickets')}
                    className="ChooseTicketsForm__Modal"
                    ref={buyModalRef}
                    displayModal={false}
                    displayActions={false}
                    displayCloseButton={false}
                    scrollContent={true}
                    width={modalWidth}
                    destroyOnClose
                    openAction={() => {
                        this.setState({
                            modal: t('URL:ticket-purchase/choose')
                        });
                        history.push(
                            `/${locale}/${entity.alias}/${t('URL:ticket-purchase/choose')}`
                        );
                    }}
                    cancelAction={() => {
                        this.setState({
                            modal: null
                        });
                        history.push(
                            `/${locale}/${entity.alias}`
                        );
                    }}
                >
                    <ChooseTicketsForm history={history} modal={modal} available={available} sold={sold} hideModal={handleHideModal} />
                </FundkyModal>
            </>
        );
    }

}

BuyTicketBtn.defaultProps = {
    template: "button",//"menu",//
    plural: false
};

BuyTicketBtn.propTypes = {};

export default translate('BuyTicketBtn')(BuyTicketBtn);
